module.exports = __webpack_public_path__ + "static/media/time.36597a32.svg";